import { _ as r } from "../internals/export.js";
import { a } from "../internals/array-buffer.js";
import { a as t } from "../internals/array-buffer-basic-detection.js";
r({
  global: !0,
  constructor: !0,
  forced: !t
}, {
  DataView: a.DataView
});